import React, { lazy, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { ADMIN_API, USER_API } from './common/common';
import { isRealAuthToken, Logout } from './common/Funcation';
import ChangePassword from './pages/ChangePassword';
import DepositWithdraw from './pages/DepositWithdraw';
import Maintenance from './pages/Maintenance'
import MultiMarket from './pages/MultiMarket/MultiMarket';
import MyAccount from './pages/MyAccount';
import MyAccountMobile from './pages/MyAccountMobile ';
import Cricket from './pages/Sport/Cricket';
import Soccer from './pages/Sport/Soccer';
import Tennis from './pages/Sport/Tennis';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import { getApi, postApi, postApiAdmin, sendEvent, socketConnect } from './service';
import Sports from './pages/Inplay/Sports';
import Casino from './pages/Inplay/Casino';
import Leagues from './pages/Inplay/Leagues';
import BalanceOverview from './components/Profile/BalanceOverview';
import AccountStatementNew from './components/Profile/AccountStatementNew';
import Setting from './components/Profile/Setting';
import P2Ptransfer from './components/Profile/P2Ptransfer';
import BetHistory from './components/Profile/BetHistory.jsx';
import CurrentBet from './components/Profile/CurrentBet';
import ProfitLoss from './components/Profile/ProfitLoss.jsx';
import ActivityLogNew from './components/Profile/ActivityLogNew';
import MyProfile from './components/Profile/ActivityLogNew copy';
import P2PtransferLog from './components/Profile/P2PtransferLog';
import PageNotFound from './pages/PageNotFound';
import CheckResultsMobile from './pages/CheckResultsMobile';
import { store } from './redux/store';
const envDomain = process.env.REACT_APP_DOMAIN
// import Home from './pages/Home'
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));


const cookies = new Cookies()
const Router = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const HeaderData = useSelector((e: any) => e.Header);
    const isMaintenance = useSelector((e: any) => e.domainDetails?.isMaintenance === true);
    const [siteChecked, setSiteChecked] = useState(false);

    useEffect(() => {
        const authToken = cookies.get('skyTokenFront')
        if (isRealAuthToken(authToken)) {
            getHeaderDetails()
            getMarketListDetails()
        }
        socketConnect(dispatch, (flag: any) => {
            if (flag) {
                setTimeout(() => {
                    sendEvent('GET_LIVE_MATCH_COUNT_FOR_VELKI', {})
                }, 500);
            }
        }, () => store.getState())
        getDomainDetails()
        return () => {

        }
    }, [])

    useEffect(() => {
        const authToken = cookies.get('skyTokenFront')
        const userId = HeaderData?._id
        if (!isRealAuthToken(authToken) || !userId) return
        const signUpTimer = setTimeout(() => {
            sendEvent('SIGN_UP', { userId })
        }, 500)
        const verifyTimer = setTimeout(() => {
            sendEvent('VERIFY_TOKEN', { userId, token: authToken })
            sendEvent('UPDATE_USER_BALANCE', { userId })
        }, 700)
        return () => {
            clearTimeout(signUpTimer)
            clearTimeout(verifyTimer)
        }
    }, [HeaderData?._id])

    const getHeaderDetails = async () => {
        let data = {
            api: USER_API.GET_PROFILE,
            value: {
            },
        }
        await getApi(data).then(function (response) {
            dispatch({ type: 'HEADER_DETAILS', payload: response.data.data })
            if (response.data.data.newPassword && window.location.pathname !== '/change/password') {
                window.location.href = '/change/password'
            }
        }).catch(err => {
            if (err.response.data.statusCode === 401) {
                Logout()
                window.open('/login')
            }
        })
    }
    const getDomainDetails = async () => {
        let data = {
            api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
            value: {
                // domain: envDomain ? envDomain : window.location.hostname
                domain: window.location.hostname
            },
        }
        await postApiAdmin({ ...data, anonymous: true }).then(function (response) {
            if (response.data.data) {
                dispatch({ type: 'DOMAIN_DETAILS', payload: response.data.data })
                if (response?.data?.data?.isMaintenance === true) {
                    if (window.location.pathname.toLowerCase() !== '/maintenance') {
                        navigate('/maintenance', { replace: true })
                    }
                }
            }
            else {
                dispatch({ type: 'DOMAIN_DETAILS', payload: null })
                navigate('/404')
            }
        }).catch(err => {
            // Site settings are public. A 401 here is not the player session.
            dispatch({ type: 'DOMAIN_DETAILS', payload: null })
            if (err?.response?.data?.statusCode !== 401) {
                navigate('/404')
            }
        }).finally(() => {
            setSiteChecked(true)
        })
    }
    const getMarketListDetails = async () => {
        let data = {
            api: USER_API.MARKET_LIST,
            value: {
            },
        }
        await getApi(data).then(function (response) {
            dispatch({ type: 'MARKET_LIST_DETAILS', payload: response.data.data })
        }).catch(err => {
            if (err.response.data.statusCode === 401) {
                Logout()
                window.open('/login')
            }
        })
    }
    useEffect(() => {
        if (!siteChecked || !isMaintenance) return
        if (window.location.pathname.toLowerCase() === '/maintenance') return
        navigate('/maintenance', { replace: true })
    }, [siteChecked, isMaintenance, navigate])

    if (!siteChecked) return null
    if (isMaintenance) return <Maintenance />

    return (
        <>
            <Routes>
                <Route path={`/404`} element={<PageNotFound />} />
                <Route path={`/`} element={<Home />} />
                <Route path={`/login`} element={<PublicRoute><Login /></PublicRoute>} />
                <Route path={`/profile`} element={<PrivateRoute><MyAccount /></PrivateRoute>} >
                    <Route path={`:tab/`} element={<PrivateRoute><MyAccount /></PrivateRoute>} />
                    <Route path={`/profile`} element={<PrivateRoute><MyAccount /></PrivateRoute>} />
                </Route>
                <Route path={`/user/:tab/`} element={<PrivateRoute><MyAccount /></PrivateRoute>} />
                <Route path={`/myAccount`} element={<PrivateRoute><MyAccountMobile /></PrivateRoute>} />
                <Route path={`/d-w`} element={<PrivateRoute><DepositWithdraw /></PrivateRoute>} />
                <Route path={`/change/password`} element={<><ChangePassword /></>} />
                <Route path={`/maintenance`} element={<Maintenance />} />


                <Route path={`/sports`} element={<Sports />} />
                <Route path={`/casino`} element={<Casino />} />
                <Route path={`/leagues`} element={<Leagues />} />
                <Route path={`/balance-overview`} element={<PrivateRoute><BalanceOverview /></PrivateRoute>} />
                <Route path={`/account-statement`} element={<PrivateRoute><AccountStatementNew /></PrivateRoute>} />
                <Route path={`/bets-history`} element={<PrivateRoute><BetHistory /></PrivateRoute>} />
                <Route path={`/current-bets`} element={<PrivateRoute><CurrentBet /></PrivateRoute>} />
                <Route path={`/profit-and-loss`} element={<PrivateRoute><ProfitLoss /></PrivateRoute>} />
                <Route path={`/active-log`} element={<PrivateRoute><ActivityLogNew /></PrivateRoute>} />
                <Route path={`/my-profile`} element={<PrivateRoute><MyProfile /></PrivateRoute>} />
                <Route path={`/p2p-transfer`} element={<PrivateRoute><P2Ptransfer /></PrivateRoute>} />
                <Route path={`/p2p-transfer-log`} element={<PrivateRoute><P2PtransferLog /></PrivateRoute>} />
                <Route path={`/setting`} element={<PrivateRoute><Setting /></PrivateRoute>} />



                <Route path={`/cricket`} element={<Cricket />} />
                <Route path={`/soccer`} element={<Soccer />} />
                <Route path={`/tennis`} element={<Tennis />} />
                <Route path="/multimarket" element={<MultiMarket />} />
                <Route path={`/multimarket/:eventId/:marketId`} element={<MultiMarket />} />
                <Route path={`/result`} element={<CheckResultsMobile />} />
            </Routes>
        </>
    )
}

export default Router